import { useEffect } from 'react';

/**
 * Cuberto Mouse Follower — default dot + circle ring style
 *
 * public/index.html already loads:
 *   <link rel="stylesheet" href="https://unpkg.com/mouse-follower@1/dist/mouse-follower.min.css" />
 *   <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js"></script>
 *   <script src="https://unpkg.com/mouse-follower@1/dist/mouse-follower.min.js"></script>
 *
 * Attributes used in JSX:
 *   data-cursor-text="view case"   → filled circle with text (like screenshot)
 *   data-cursor-img="https://…"    → circle grows, shows image inside circle
 */
export default function Cursor() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const init = () => {
      if (!window.MouseFollower || !window.gsap) return;

      window.MouseFollower.registerGSAP(window.gsap);

      const style = document.createElement('style');
      style.textContent = `
        /* ── Hide native cursor ─────────────────────────────── */
        *, *::before, *::after { cursor: none !important; }

        /* ── Cursor always on top, NEVER intercepts clicks ──── */
        .mf-cursor {
        
          z-index: 99999 !important;
          pointer-events: none !important;
          
        }
        .mf-cursor-wrapper {
          pointer-events: none !important;
        }

        @media (max-width: 767px) {
          *, *::before, *::after { cursor: auto !important; }
          .mf-cursor { display: none !important; }
        }
          .mf-cursor-inner {
  background-color: #ff0000ff !important;
}
.mf-cursor-text {

  color: var(--black) !important;
}
      `;
      document.head.appendChild(style);

      const cursor = new window.MouseFollower({
        container:       document.body,
        dataAttr:        'cursor',
        speed:           0.65,
        ease:            'expo.out',
        skewing:         0,
        skewingText:     2,
        skewingMedia:    1.5,
        skewingDelta:    0,
        skewingDeltaMax: 0.15,
        stickDelta:      0,
        hideOnLeave:     false,
        stateDetection: {
          '-pointer': 'a,button,[data-cursor-pointer]',
          '-hidden':  'iframe,[data-cursor-hidden]',
        },
      });

      window.__cursor = cursor;
    };

    if (window.MouseFollower && window.gsap) {
      init();
    } else {
      window.addEventListener('load', init, { once: true });
    }

    return () => {
      try { window.__cursor && window.__cursor.destroy(); } catch (_) {}
      delete window.__cursor;
    };
  }, []);

  return null;
}
